import { useNavigate } from "react-router-dom";
import { Button } from "../shared/button";
import { LogIn, UserRound, LogOut } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../shared/dropdown-menu";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { useAuthState } from "@/hooks/useAuthState";
import { User } from "@supabase/supabase-js";

export const AuthButtons = () => {
  const navigate = useNavigate();
  const { user } = useAuthState();

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      toast.error("Error signing out");
    } else {
      toast.success("Signed out successfully");
      navigate('/');
    }
  };

  if (user) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="outline" 
            className="text-white bg-[#CA0079] gap-[11px] whitespace-nowrap px-4 sm:px-[31px] py-[10px] sm:py-[13px] rounded-[10px] hover:bg-[#a0005f] transition-colors text-sm sm:text-base"
          >
            <UserRound className="h-4 w-4" />
            {user.email}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={handleLogout}>
            <LogOut className="h-4 w-4 mr-2" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <Button 
      variant="outline"
      onClick={() => navigate('/login')}
      className="text-white bg-[#CA0079] gap-[11px] whitespace-nowrap px-4 sm:px-[31px] py-[10px] sm:py-[13px] rounded-[10px] hover:bg-[#a0005f] transition-colors text-sm sm:text-base"
    >
      <LogIn className="h-4 w-4" />
      Sign in
    </Button>
  );
};